// @mui material components
import Card from "@mui/material/Card";
import { isValid } from 'date-fns';
// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

// Material Dashboard 2 React example components
import TimelineItem from "dashboard/examples/Timeline/TimelineItem";

function OrdersTimeLine({ orderDelivery, statusTable, formatDateString }) {
  return (
    <Card sx={{ height: "100%", boxShadow:"none"}}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Aperçu
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        <TimelineItem
          color={orderDelivery.step.stage < 2 ? "success" : "light"}
          icon="notifications"
          title="Commande reçu"
          dateTime={isValid(orderDelivery.createdAt) ? formatDateString(orderDelivery.createdAt) : ""}
        />
        <TimelineItem
          color={orderDelivery.step.stage === 2 ? "success" : "light"}
          icon="inventory_2"
          title={`Commande ${statusTable[2].status}`}
          dateTime={isValid(orderDelivery.updatedAt) ? formatDateString(orderDelivery.updatedAt) : ""}
        />
        {orderDelivery.step.stage === 3  ?(<TimelineItem
          color="error"
          icon="cancel"
          title={`Commande ${statusTable[3].status}`}
          lastItem
          dateTime={isValid(orderDelivery.updatedAt) ? formatDateString(orderDelivery.updatedAt) : ""}
        />) : (<>
        <TimelineItem
          color={orderDelivery.step.stage === 4  ? "success" : "light"}
          icon="local_shipping"
          title={`Commande ${statusTable[4].status}`}
          dateTime={isValid(orderDelivery.couriersAt) ? formatDateString(orderDelivery.couriersAt) : ""}
        />
        <TimelineItem
          color={orderDelivery.step.stage === 5 ? "success" : "light"}
          icon="done"
          title={`Commande ${statusTable[5].status}`}
          dateTime={isValid(orderDelivery.delivredAt) ? formatDateString(orderDelivery.delivredAt) : ""}
          lastItem
        /></>)}
      </MDBox>
    </Card>
  );
}

export default OrdersTimeLine;
